import { invokeApi } from "../../bl_libs/invokeApi";

export const getTrackersApi = async ({
  page = 1,
  limit = 100,
  search = "",
  status = "",
  kind = "",
  category = "",
  sortBy = "updatedAt",
  sortDir = "desc",
} = {}) => {
  const queryParams = [];
  if (page) queryParams.push(`page=${encodeURIComponent(page)}`);
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`);
  if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
  if (status && status !== "all") queryParams.push(`status=${encodeURIComponent(status)}`);
  if (kind && kind !== "all") queryParams.push(`kind=${encodeURIComponent(kind)}`);
  if (category && category !== "all") queryParams.push(`category=${encodeURIComponent(category)}`);
  if (sortBy) queryParams.push(`sortBy=${encodeURIComponent(sortBy)}`);
  if (sortDir) queryParams.push(`sortDir=${encodeURIComponent(sortDir)}`);

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

  const requestObj = {
    path: `/api/tracker${queryString}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const getTrackerDetailApi = async (idOrSlug) => {
  const requestObj = {
    path: `/api/tracker/${idOrSlug}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const getPublicTrackerDetailApi = async (slug) => {
  const requestObj = {
    path: `/api/tracker/public/${encodeURIComponent(slug)}`,
    method: "GET",
  };
  return invokeApi(requestObj);
};

export const submitPublicTrackerApi = async (slug, data = {}) => {
  const token = localStorage.getItem("token");
  const headers = {};
  if (token) {
    headers["x-sh-auth"] = token;
  }

  const requestObj = {
    path: `/api/tracker/public/${encodeURIComponent(slug)}/submissions`,
    method: "POST",
    headers,
    postData: {
      password: data.password || "",
      formId: data.formId || "",
      answers: data.answers || {},
    },
  };
  return invokeApi(requestObj);
};

export const addTrackerApi = async (data) => {
  const requestObj = {
    path: `/api/tracker`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const updateTrackerApi = async (id, data) => {
  const requestObj = {
    path: `/api/tracker/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const deleteTrackerApi = async (id) => {
  const requestObj = {
    path: `/api/tracker/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const duplicateTrackerApi = async (id) => {
  const requestObj = {
    path: `/api/tracker/duplicate/${id}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const archiveTrackerApi = async (id) => {
  const requestObj = {
    path: `/api/tracker/archive/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
